import { Type } from "class-transformer";
import { ValidateNested } from "class-validator";
import { InspectionOutlineDto } from "@/dto/inspection/InspectionOutlineDto.ts";
import { InspectionImageDto } from "@/dto/inspection/InspectionImageDto.ts";
import { InspectionOtherCpoDto } from "@/dto/inspection/InspectionOtherCpoDto.ts";

export abstract class BaseStationInspectionDto {
    @ValidateNested()
    @Type(() => InspectionOutlineDto)
    inspectionOutline: InspectionOutlineDto;

    @Type(() => InspectionImageDto)
    inspectionImageList: InspectionImageDto[];

    @ValidateNested({ each: true })
    @Type(() => InspectionOtherCpoDto)
    inspectionOtherCpoList: InspectionOtherCpoDto[];

    constructor() {}
}
